import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiService } from './service/api.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        ApiService
    ]
})
export class CoreModule { }
